import Helpers from "../../resources/js/utils/helpers";

export default class Hero extends Helpers {
  constructor() {
    super();
    this.heroBanner = document.querySelector('.hero-banner');
    if(this.heroBanner) {
      this.form = this.heroBanner.querySelector('.js-chat-form-hero');
      this.textArea = this.form.querySelector('textarea');
      this.form && this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
      this.textAreaSubmit();
    }
  }

  textAreaSubmit() {
    if (!this.textArea) return;
    this.textArea.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        if (e.shiftKey) return;
        e.preventDefault();
        this.form.requestSubmit();
      }
    })
  }

  handleFormSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    let text = formData.get('text');
    text = text.trim();
    if (!text && !themeVars.pageChat) return;
    window.location.href = `${themeVars.pageChat.url}?question=${encodeURIComponent(text)}`;
  }
}

new Hero()
